import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TwcPopoverFocusCloseDirective } from '../../directives/popover-focus-out-close/popover-focus-out-close.directive';
import { ToolbarComponent } from './toolbar.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule, TwcPopoverFocusCloseDirective],
    declarations: [ToolbarComponent],
    exports: [ToolbarComponent],
})
export class ToolbarModule {}
